import { DEFAULT_DATE_FORMAT } from '@aslanpay/portal-common-lib';
import {
  getHours,
  isAfter,
  isBefore,
  isMatch,
  isSameDay,
  isValid,
  parse,
  parseISO,
} from 'date-fns';

import { CountryCode, postcodeValidator } from 'postcode-validator';

export const validateEmail = (value: string): boolean => {
  if (value === undefined || value === null) return false;

  return /^(?=.{1,256})(?=.{1,64}@[a-zA-Z0-9.-]{1,255}$)(?=[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$)(?!.*[.]{2})(?!.*''.*)[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/.test(
    value
  );
};

export const validateDate = (value: string): boolean => {
  if (value === undefined) return false;

  if (isValid(parseISO(value)) && isMatch(value, 'yyyy-MM-dd')) {
    return true;
  }

  if (
    isValid(parse(value, DEFAULT_DATE_FORMAT, new Date())) &&
    isMatch(value, DEFAULT_DATE_FORMAT)
  ) {
    return true;
  }

  return false;
};

export const validatePostcode = (value: string, countryCode: string): boolean => {
  if (value === undefined) return false;

  return postcodeValidator(value, countryCode in CountryCode ? countryCode : 'INTL');
};

export const validateOnlyLettersAndSymbols = (value: string) => {
  if (value === undefined || value === null) return false;

  return /^[a-zA-ZÀ-ÿ\s'.-]+$/.test(value);
};

export const validateOnlyLettersAndNumber = (value: string) => {
  if (value === undefined || value === null) return false;

  return /^[a-zA-Z0-9]+$/.test(value);
};

export const validateDateBefore = (startDate: Date, endDate: Date) => {
  return isBefore(startDate, endDate);
};

export const validateFutureDate = (value: string) => {
  if (value === undefined) return false;

  if (isValid(parseISO(value))) {
    return isAfter(parseISO(value), new Date());
  }

  if (isValid(parse(value, DEFAULT_DATE_FORMAT, new Date()))) {
    return isAfter(parse(value, DEFAULT_DATE_FORMAT, new Date()), new Date());
  }

  return false;
};

export const validateSalaryRange = (value: number) => {
  return value >= 4000 && value <= 250000;
};

export const isSameDayButBeforeUTCHour = (value: string, hour: number) => {
  const currentDate = new Date();
  const date = new Date(value);

  if (isSameDay(currentDate, date)) {
    if (getHours(currentDate) < hour) {
      return true;
    }
  }

  return false;
};
